import { Box, Checkbox } from "@mui/material";
import { useBoundStore } from "useStore";

export default function CheckboxHeader() {
  const cmEditedRows = useBoundStore((state) => state.cmEditedRows);
  const setAllCmEditedRows = useBoundStore((state) => state.setAllCmEditedRows);
  const rows = useBoundStore((state) => state.campaignManagerRows);

  const allSelected = rows.length > 0 && rows.every((r) => cmEditedRows[r.id]);
  const someSelected =
    rows.length > 0 && Object.keys(cmEditedRows).length > 0 && !allSelected;

  const handleToggleAll = () => {
    if (allSelected) {
      setAllCmEditedRows({});
    } else {
      const newEditedRows = {};
      rows.forEach((row) => {
        newEditedRows[row.id] = row;
      });
      setAllCmEditedRows(newEditedRows);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Checkbox
        checked={allSelected}
        indeterminate={someSelected}
        onChange={handleToggleAll}
        sx={{
          p: 0,
          "&.Mui-checked": {
            color: "#002878",
          },
          "&.MuiCheckbox-indeterminate": {
            color: "#002878",
          },
        }}
      />
    </Box>
  );
}
